import React from 'react';
/**
 * DjayMenuPanel — The "Wat zullen we doen?" popover above the floating
 * Djay avatar.
 *
 * Extracted from FloatingDjay.tsx (audit P1, ronde 2 2026). Pure
 * presentation component — receives items + interaction callbacks,
 * renders the panel with staggered entry animations and hover/focus
 * affordances. No internal state, no domain knowledge.
 */

import { motion, AnimatePresence } from 'framer-motion';
import type { PanelMenuItem } from '../menuConfig';
interface DjayMenuPanelProps {
  isOpen: boolean;
  items: PanelMenuItem[];
  hoveredItemId: string | null;
  shouldAnimate: boolean;
  onItemHover: (item: PanelMenuItem) => void;
  onItemLeave: () => void;
}
export function DjayMenuPanel({
  isOpen,
  items,
  hoveredItemId,
  shouldAnimate,
  onItemHover,
  onItemLeave
}: DjayMenuPanelProps) {
  return <AnimatePresence data-id="element-2819">
      {isOpen && <motion.div initial={shouldAnimate ? {
      opacity: 0,
      y: 10,
      scale: 0.95
    } : false} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={shouldAnimate ? {
      opacity: 0,
      y: 10,
      scale: 0.95
    } : false} transition={{
      duration: 0.2
    }} className="absolute bottom-full right-0 mb-4 w-64 md:w-72 bg-white rounded-2xl shadow-xl border border-slate-100 p-3 origin-bottom-right" data-id="element-2820">
          <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-b border-r border-slate-100 transform rotate-45" data-id="element-2821" />

          <div className="relative z-10" data-id="element-2822">
            <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold mb-2 px-2" data-id="element-2823">
              Wat zullen we doen?
            </p>
            <div className="space-y-1.5" data-id="element-2824">
              {items.map((item, i) => {
            const isHovered = hoveredItemId === item.id;
            return <motion.button key={item.id} initial={shouldAnimate ? {
              opacity: 0,
              x: 12
            } : false} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.05,
              duration: 0.25,
              ease: [0.32, 0.72, 0, 1]
            }} onClick={item.onClick} onMouseEnter={() => onItemHover(item)} onMouseLeave={onItemLeave} onFocus={() => onItemHover(item)} onBlur={onItemLeave} whileHover={shouldAnimate ? {
              x: 2
            } : undefined} whileTap={shouldAnimate ? {
              scale: 0.97
            } : undefined} className={`w-full flex items-center gap-2 px-3 py-2.5 ${item.bgClass} ${item.hoverClass} ${item.textClass} rounded-xl text-sm font-semibold transition-all relative ${isHovered ? 'ring-2 ring-offset-1 ring-current/30 shadow-sm' : ''}`} data-id="element-2825">
                    <motion.span animate={isHovered && shouldAnimate ? {
                rotate: [0, -10, 10, 0],
                scale: [1, 1.15, 1]
              } : undefined} transition={{
                duration: 0.4
              }} className="flex-shrink-0" data-id="element-2826">
                      {item.icon}
                    </motion.span>
                    <span className="flex-1 text-left" data-id="element-2827">{item.label}</span>
                    {isHovered && shouldAnimate && <motion.span initial={{
                opacity: 0,
                x: -4
              }} animate={{
                opacity: 1,
                x: 0
              }} className="text-current/60" aria-hidden="true" data-id="element-2828">
                        →
                      </motion.span>}
                  </motion.button>;
          })}
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}